import React from "react";

export const Dashboard = React.lazy(
  () => import("@/features/dashboard/pages/DashboardPage.tsx"),
);
